export const emailRecipientRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const emailBodyTextRegex = /[/\\:<>]/g;
export const phoneNumberRegex = /^(\+\d{1,3}|00\d{1,3})\d{4,}$/;
export const sixDigitRegex = /^\d{6}$/;
export const urlRegex = /https?:\/\/\S+/;
export const rtmpStreamQrcodeRegex = new RegExp('^rtmp://[^/]*/[A-Za-z0-9]{3}$');
export const tabletPatternRegex = /ipad|android(?!.*mobile)|tablet|kindle|silk|playbook|nexus(?!.*mobile)/i;